import { Box, Card, Container, Typography } from '@mui/material';
import { FC } from 'react';
import TransdevThemeProvider from './TransdevThemeProvider';

const ErrorPage: FC = () => {
  return (
    <TransdevThemeProvider>
      <Container fixed maxWidth="sm">
        <Card>
          <Box py={2} px={4}>
            <Typography variant="h5">Användaren hittades ej!</Typography>
            <Typography variant="subtitle2">
              Kontakta trafikledare för att få hjälp.
            </Typography>
          </Box>
        </Card>
      </Container>
    </TransdevThemeProvider>
  );
};

export default ErrorPage;
